import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'app/shared/services/api.service';
@Component({
  selector: 'app-add-payment',
  templateUrl: './add-payment.component.html',
  styleUrls: ['./add-payment.component.scss']
})
export class AddPaymentComponent implements OnInit {
    @ViewChild('vform') validationForm: FormGroup;
  
    transactionForm:FormGroup;
    selectedValue:'';
    users:any
    transactionFormSubmitted:boolean=false;
    paymentMode=[]
    selectedPaymentMode=null
    paymentModeId='631ada2ace5c666542591bf6'
    enrolmentData:any
    constructor(private formBuilder: FormBuilder,
                public toastr: ToastrService,
                public apiService:ApiService,
                private route:Router) { }
  
    ngOnInit() {
      this.getAllUsers()
      this.paymentModeList()
      this.transactionForm=this.formBuilder.group({
        amount: ['', Validators.required],
        payment_method: ['', Validators.required],
        user: ['', Validators.required],
      })
    }
    getAllUsers(){
      this.apiService.getAllUsers(1,100).subscribe((res:any)=>{
        this.users =res.data.items  
        console.log('users list ==',this.users)
      })
    }
    getEnrollmentStudentById(){
      this.apiService.getEnrolmentByUserId(this.selectedValue).subscribe((res:any)=>{
        console.log('res=>',res)
        this.enrolmentData=res.data
      })
    }
    getUserId(event:any){
      this.selectedValue=event.target.value
      console.log('select user id',this.selectedValue)
      this.getEnrollmentStudentById()
    }
   
    get rf() {
      return this.transactionForm.controls;
    }
    paymentModeList(){
      this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
        console.log('payment mode List', res)
        this.paymentMode = res.data
      })
    }
    getPaymentModeId(event:any){
      console.log('selectedPaymentMode',this.selectedPaymentMode)
    }
    submit(){
      let pendingFees=this.enrolmentData.pending_fee - Number(this.enrolmentData.paid_amount)
      let body={
        paid_amount: this.transactionForm.value.amount,
        student: this.selectedValue,
        entity_id: this.enrolmentData._id,
        // course_id:this.enrolmentData.course_id,
        net_amount:this.enrolmentData.net_fees,
        total_amount:this.enrolmentData.total_amount,
        pendingAmount:pendingFees,
        payment_status:'received',
        mode:this.selectedPaymentMode,
      }
      console.log('transaction val',body)
     this.apiService.createTransaction(body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log('transaction create res',res)
        this.toastr.success(res.message)
      this.route.navigate(['/transaction/transaction-list'])    
      }
      else{this.toastr.error(res.error)
      }
      this.transactionFormSubmitted = true;
    if (this.transactionForm.invalid) {
      return;
    }
  })

    }
  
   back(){
    this.route.navigate(['/transaction/transaction-list'])    
   } 
    
}
  
